(function () {
	// Initialize read more functionality on page load
	function initReadMore() {
		const contentAreas = document.querySelectorAll(".multicolumn-card__info");

		contentAreas.forEach((contentArea) => {
			// Reset any existing state
			contentArea.style.maxHeight = "";
			contentArea.style.overflow = "";
			contentArea.classList.remove("multicolumn-card__info--collapsed", "multicolumn-card__info--expanded");

			const expandButton = contentArea.closest('.multicolumn-card__content-wrapper').querySelector('.multicolumn-card__expand');
			if (expandButton) {
				// Always start with the button hidden
				expandButton.hidden = true;
				expandButton.setAttribute('hidden', '');
				// Remove any existing event listeners
				expandButton.replaceWith(expandButton.cloneNode(true));
			}

			// Force a reflow to get accurate scrollHeight measurement
			contentArea.style.maxHeight = "none";
			contentArea.style.overflow = "visible";
			const contentHeight = contentArea.scrollHeight;
			const maxHeight = 200; // Set your desired max height here
			const newExpandButton = contentArea.closest('.multicolumn-card__content-wrapper').querySelector('.multicolumn-card__expand');

			if (contentHeight > maxHeight) {
				// Content is too tall, show the expand button and truncate content
				contentArea.style.maxHeight = `${maxHeight}px`;
				contentArea.style.overflow = "hidden";
				contentArea.classList.add("multicolumn-card__info--collapsed");

				// Show the expand button
				if (newExpandButton) {
					newExpandButton.hidden = false;
					newExpandButton.removeAttribute('hidden');
					newExpandButton.textContent = "Read More...";

					// Add click event to expand/collapse
					newExpandButton.addEventListener('click', function () {
						if (contentArea.classList.contains('multicolumn-card__info--collapsed')) {
							// Expand
							contentArea.style.maxHeight = contentArea.scrollHeight + "px";
							contentArea.classList.remove('multicolumn-card__info--collapsed');
							contentArea.classList.add('multicolumn-card__info--expanded');
							newExpandButton.textContent = "Read Less";
						} else {
							// Collapse
							contentArea.style.maxHeight = `${maxHeight}px`;
							contentArea.classList.add('multicolumn-card__info--collapsed');
							contentArea.classList.remove('multicolumn-card__info--expanded');
							newExpandButton.textContent = "Read More...";
						}
					});
				}
			} else {
				// Content fits, keep button hidden and content visible
				contentArea.style.maxHeight = "none";
				contentArea.style.overflow = "visible";
				contentArea.classList.remove("multicolumn-card__info--collapsed");

				// Ensure the expand button stays hidden
				if (newExpandButton) {
					newExpandButton.hidden = true;
					newExpandButton.setAttribute('hidden', '');
				}
			}
		});
	}

	// Initialize on page load
	document.addEventListener("DOMContentLoaded", function () {
		initReadMore();
	});

	// Reinitialize when Shopify sections are loaded (for theme editor)
	document.addEventListener("shopify:section:load", function () {
		initReadMore();
	});
})();
